import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3afa183c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No races found, please return later. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_data_table = _resolveComponent("n-data-table")!

  return (_openBlock(), _createBlock(_component_n_data_table, {
    key: _ctx.rerenderKey,
    columns: _ctx.columns,
    data: _ctx.data,
    class: "table races-table",
    "scroll-x": "1100",
    "max-height": "70vh",
    "onUpdate:sorter": _ctx.updateSort,
    "onUpdate:expandedRowKeysOnce": _ctx.updateExpandedRowKeys,
    "expanded-row-keys": _ctx.expandedRowKeys,
    "row-class-name": "interactable-row",
    "row-props": (rowData, rowIndex) => ({ onClick: () => _ctx.rowClick(rowData) }),
    size: _ctx.breakpoints.sDown.matches ? 'small' : 'medium'
  }, {
    empty: _withCtx(() => [
      _createVNode(_component_n_alert, { type: "warning" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["columns", "data", "onUpdate:sorter", "onUpdate:expandedRowKeysOnce", "expanded-row-keys", "row-props", "size"]))
}